import { QueryClient } from '@tanstack/react-query';
import {
  CONVENIENCE_DISPATCH_ALL_DELIVERIES_QUERY_KEY,
  CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY,
} from 'src/hooks/useConvenienceDispatchDeliveries.query';
import { SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY } from 'src/hooks/useQueryShipmentOrderLegRuns';

// 稼働表(/truck-shifts/)のシフト変更後に無効化すべきクエリをまとめて invalidate する。
// カード型配車(/convenience-dispatches/)の勤務リストは deliveries クエリ(staleTime: Infinity)由来で、
// 稼働表側の mutation では従来 truck_shifts しか invalidate しておらず、アプリ内で画面を戻っても
// シフト変更が反映されなかった。ここで両画面のクエリを prefix invalidate して整合させる。
// また稼働表でシフトを削除すると配車済み案件が未配車に戻る(shift_truck 削除で leg_run_operations が
// dependent: :destroy される)ため、未割当リストの元となる leg-runs クエリも invalidate する。
export const invalidateTruckShiftQueries = (queryClient: QueryClient): void => {
  void queryClient.invalidateQueries({ queryKey: ['useQueryTruckShifts'] });
  void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY] });
  void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_ALL_DELIVERIES_QUERY_KEY] });
  void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
};
